import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponent';
import { MemberDetailsDto, MemberDetailsDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentView } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentview';
import { MemberDetailsRowViewImpl } from './memberdetailsrowview';
import { MemberDetailsRowCSSStyleImpl } from './memberdetailsrowcss';
import { ManageGroupType } from '../managegrouptype';
import { UIComponentCSSStyle } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentcss';


export interface MemberDetailsRowComponentProps extends UIComponentProps
{
    manageGroupType: ManageGroupType;
    memberDetailsDto: MemberDetailsDto;
    position: number;

    onDeleteMemberClicked(memberDetailsDto: MemberDetailsDto): void;
    onAddMemberClicked(memberDetailsDto: MemberDetailsDto): void;
}

export interface MemberDetailsRowComponentHandler extends UIComponentHandler
{
    onDeleteClicked(): void;
    onAddClicked(memberDetailsDto: MemberDetailsDto): void;
}

export class MemberDetailsRowComponent extends UIComponentImpl<MemberDetailsRowComponentProps, UIComponentState, UIDataModel> implements MemberDetailsRowComponentHandler
{
    constructor(props: MemberDetailsRowComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MemberDetailsRowViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MemberDetailsRowCSSStyleImpl(applicationContext);
    }

    onDeleteClicked(): void {
        this.props.onDeleteMemberClicked(this.props.memberDetailsDto);
    }
    onAddClicked(memberDetailsDto: MemberDetailsDto): void 
    {
        let memberDto = new MemberDetailsDtoImpl();
        memberDto.setMemberName(memberDetailsDto.getMemberName());
        memberDto.setMsisdn(memberDetailsDto.getMsisdn());

        (memberDetailsDto as MemberDetailsDtoImpl).setMemberName("");
        (memberDetailsDto as MemberDetailsDtoImpl).setMsisdn("");
        this.props.onAddMemberClicked(memberDto);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/managegroup/membersdetails/memberdetailsrowcomponent.tsx